import { ALL_IMAGE_TYPES } from "../constants/images.js";

export const MARKING_STATES = {
  ACCEPTED: "accepted",
  CREATED: "created",
  CREATING: "creating",
  CONVERGED: "converged",
  CONVERGING: "converging",
  DELETED: "deleted",
  DELETING: "deleting",
  DESTROYED: "destroyed",
  DESTROYING: "destroying",
  DUE: "due",
  ERRORED: "errored",
  ERRORING: "erroring",
  EXPIRED: "expired",
  IMAGING: "imaging",
  LOCKED: "locked",
  OVERDUE: "overdue",
  PAID: "paid",
  PENDING: "pending", // old being decomissioned in favour of pendingObject and pendingSubject
  PENDING_OBJECT: "pendingObject",
  PENDING_SUBJECT: "pendingSubject",
  REJECTED: "rejected",
  STARTED: "started",
  STARTING: "starting",
  STOPPED: "stopped",
  STOPPING: "stopping",
  VERIFIED: "verified",
  VERIFYING: "verifying"
};

export const MARKING_MESSAGE_STATES = {
  SAVING: "marking_message_state.saving",
  CREATED: "marking_message_state.created",
  CREATING: "marking_message_state.creating",
  LOCKED: "marking_message_state.locked",
  DELETED: "marking_message_state.deleted",
  ARCHIVED: "marking_message_state.archived",
  ERROR: "marking_message_state.error"
};

function createDisabledStateObj(functions, views, message) {
  return { functions, views, message };
}

function getCreatedDisabledStateByEntityType(type) {
  if (ALL_IMAGE_TYPES.findIndex(item => type === item) > -1) {
    return createDisabledStateObj(true, true, MARKING_MESSAGE_STATES.CREATED);
  }
  return createDisabledStateObj(false, false, null);
}

// returns an object containing a disabled and message state
export function getDisabledStateFromMarking(marking, type) {
  switch (marking) {
    // Infrastructure creation states
    case MARKING_STATES.CREATING:
      return createDisabledStateObj(true, true, MARKING_MESSAGE_STATES.SAVING);

    case MARKING_STATES.CONVERGING:
    case MARKING_STATES.VERIFYING:
      return createDisabledStateObj(
        true,
        true,
        MARKING_MESSAGE_STATES.CREATING
      );

    // Infrastructure mixed states based on type

    case MARKING_STATES.CREATED:
      return getCreatedDisabledStateByEntityType(type);

    // Infrastructure ready states
    case MARKING_STATES.CONVERGED:
    case MARKING_STATES.VERIFIED:
    case MARKING_STATES.STARTING:
    case MARKING_STATES.STARTED:
    case MARKING_STATES.STOPPING:
    case MARKING_STATES.STOPPED:
      return createDisabledStateObj(false, false, null);

    case MARKING_STATES.LOCKED:
      return createDisabledStateObj(true, true, MARKING_MESSAGE_STATES.LOCKED);

    // Tear down states
    case MARKING_STATES.DELETING:
    case MARKING_STATES.DELETED:
    case MARKING_STATES.DESTROYING:
    case MARKING_STATES.DESTROYED:
      return createDisabledStateObj(true, true, MARKING_MESSAGE_STATES.DELETED);

    // Error states
    case MARKING_STATES.ERRORING:
    case MARKING_STATES.ERRORED:
      return createDisabledStateObj(false, false, MARKING_MESSAGE_STATES.ERROR);

    default:
      return createDisabledStateObj(false, false);
  }
}
